<button class="button small" (click)="addLayer()">Add new Layer</button>
@for (layr of config.layers; track layr; let isLast = $last) {
  <div>
    <layer [services]="serviceMappings" [item]="layr"></layer>
    @if (!isLast) {
      <div class="horizontal-rule"></div>
    }
  </div>
}